// USES getVariantIdFromUrl() and GdcAddBundleToCart() in global.js

function handleCaseSelector() {
  const caseSelectors = document.querySelectorAll('.gdc-product-quantity-option')
  const atcButton = document.querySelector('[gdc-js-add-to-cart]')
  const qtySelectors = document.querySelectorAll('[data-swatch-option]')

  function handleSelection(event) {
    const selected = event.target

    caseSelectors.forEach((selector) => selector.classList.remove('active'))
    selected.classList.add('active')
  }

  function handleCaseAddToCart(event) {
    event.preventDefault()
    event.stopPropagation()

    const quantityInput = parseInt(document.querySelector('[data-js-quantity]').value)
    const caseSelected = document.querySelector('.gdc-product-quantity-option.active')
    const caseSize = parseInt(caseSelected.dataset.caseSize)
    const productId = atcButton.dataset.productId
    const selectedVariantId = getVariantIdFromUrl()
    const totalToAdd = caseSize * quantityInput

    const items = [
      {
        id: selectedVariantId ? selectedVariantId : productId,
        quantity: totalToAdd,
          properties: {
            '_Is case': 'true',
          },
      },
    ]

    GdcAddBundleToCart(items)
  }

  function handleQuantityNotifications(event) {
    const isSoldOut = event.target.dataset.swatchSoldout

    if (isSoldOut) {
      atcButton.setAttribute("disabled", "true");
      atcButton.textContent = "Out of Stock"
    } else {
      atcButton.removeAttribute("disabled");
      atcButton.textContent = "Add to Cart"
    }
  }

  caseSelectors.forEach((selector) => selector.addEventListener('click', handleSelection))
  qtySelectors.forEach((selector) => selector.addEventListener('click', handleQuantityNotifications))
  atcButton.addEventListener('click', handleCaseAddToCart)
}

window.addEventListener('DOMContentLoaded', handleCaseSelector)
